import React, { Component } from "react";
import { connect } from "react-redux";
import Request from "../../request";
import ListDrawer from './list';
import {
    FaCalendarDay, FaCalendarTimes, FaCalendarPlus, FaCalendarWeek, FaCalendarAlt,
    FaGlobe,
    FaMapMarkedAlt,
    FaFlag,
    FaUniversity,
    FaLandmark,
    FaMountain,
    FaMonument,
    FaCity,
    FaRoad,
    FaAnchor,
    FaLeaf,
    FaIndustry,
    FaPlane,
    FaCrown,
    FaStar,
    FaFileAlt,
    FaUsers,
    FaLayerGroup,
    FaCheckCircle,
    FaTimesCircle,
    FaUndoAlt,
    FaClipboardCheck,
    FaMoneyBillWave,
    FaSpinner,
    FaHandHolding,
    FaPlayCircle
} from 'react-icons/fa';
import { Row, Col, Card } from "antd";


const countryMeta = {
    Australia: {
        icon: <FaMapMarkedAlt />,
        color: "bg-orange"
    },
    Canada: {
        icon: <FaLeaf />,
        color: "bg-red"
    },
    France: {
        icon: <FaMonument />,
        color: "bg-blue"
    },
    Germany: {
        icon: <FaIndustry />,
        color: "bg-grey"
    },
    Hungary: {
        icon: <FaLandmark />,
        color: "bg-purple"
    },
    India: {
        icon: <FaStar />,
        color: "bg-saffron"
    },
    Ireland: {
        icon: <FaGlobe />, // ❌ not in v3 → replaced below
        color: "bg-green"
    },
    Italy: {
        icon: <FaUniversity />,
        color: "bg-maroon"
    },
    Malta: {
        icon: <FaAnchor />,
        color: "bg-darkblue"
    },
    Netherlands: {
        icon: <FaRoad />,
        color: "bg-orange"
    },
    "New Zealand": {
        icon: <FaMountain />,
        color: "bg-darkgreen"
    },
    Spain: {
        icon: <FaCity />,
        color: "bg-red"
    },
    UAE: {
        icon: <FaPlane />,
        color: "bg-black"
    },
    UK: {
        icon: <FaCrown />,
        color: "bg-blue"
    },
    USA: {
        icon: <FaFlag />,
        color: "bg-blue"
    }
};

const offerExpectedMeta = {
    'Today': {
        icon: <FaCalendarDay />,
        color: "bg-red"
    },
    'This Week': {
        icon: <FaCalendarWeek />,
        color: "bg-orange"
    },
    'This Month': {
        icon: <FaCalendarAlt />,
        color: "bg-blue"
    }
}


class VisaSupportDashboard extends React.Component {
    state = {
        drawer: false,
        drawerParam: {},
        todayFollowup: {
            total: 0,
            arr: []
        },
        tommorrowFollowup: {
            total: 0,
            arr: []
        },
        missedFollowup: {
            total: 0,
            arr: []
        },
        countryWiseVisa: {},
        offerExpected: {
            "Today": { total: 0, arr: [] },
            "This Week": { total: 0, arr: [] },
            "This Month": { total: 0, arr: [] }
        },
        totalApplications: { total: 0, arr: [] },
        fileToEmbassy: { total: 0, arr: [] },
        visaApproved: { total: 0, arr: [] },
        visaRefused: { total: 0, arr: [] },
        visaWithdrawn: { total: 0, arr: [] },
        checkListIssued: { total: 0, arr: [] },
        feePaid: { total: 0, arr: [] },
        fileInProgress: { total: 0, arr: [] },
        refundWaiting: { total: 0, arr: [] },
        counsellorWiseProgress: {},
        countryWiseInProgress: {},
        branchWiseInProgress: {},
        filesReadyToProcess: { total: 0, arr: [] },
        filesHandedNotProcessed: { total: 0, arr: [] },
        pendingConsultancy: { total: 0, arr: [] }
    }


    mergeStatus(defaultObj, apiObj = {}) {
        let result = { ...defaultObj };

        Object.keys(apiObj).forEach(key => {
            if (result[key]) {
                result[key] = {
                    ...result[key],
                    ...apiObj[key]
                };
            }
        });

        return result;
    }



    loadAllApis = async (params = {}) => {

        let response = await Request.loadVisaSupportDashboard();

        this.setState({
            ...response,
            offerExpected: this.mergeStatus(this.state.offerExpected, response.offerExpected),
        });
    };


    componentDidMount() {
        this.loadAllApis()
    }

    render() {
        let { drawer, drawerParam, todayFollowup, tommorrowFollowup, missedFollowup, countryWiseVisa, offerExpected,
            totalApplications, fileToEmbassy, visaApproved, visaRefused, visaWithdrawn, checkListIssued, feePaid, fileInProgress,
            filesReadyToProcess, filesHandedNotProcessed, pendingConsultancy, refundWaiting, counsellorWiseProgress, countryWiseInProgress, branchWiseInProgress
        } = this.state
        return (
            <div className="fod-container">
                <h4 className="fod-heading">Visa Counsellor</h4>
                {drawer && <ListDrawer param={drawerParam} onClose={() => this.setState({ drawer: false })} />}
                <div className="section-tag">Follow Ups</div>
                <Row className="fod-row">
                    <Col span={6}>
                        <div className="stat-card">
                            <div className="stat-icon-wrapper bg-indigo">
                                <FaCalendarDay />
                            </div>
                            <div className="stat-data">
                                <div className="stat-label">Today's Followup</div>
                                <div className="stat-value">
                                    <span className="info-box-number">
                                        <a onClick={() => this.setState({
                                            drawer: true,
                                            drawerParam: { title: "Today Followup", arr: todayFollowup.arr, count: todayFollowup.total, bgColorClass: "bg-indigo", icon: <FaCalendarDay /> }
                                        })}>{todayFollowup.total}</a>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </Col>
                    <Col span={6}>
                        <div className="stat-card">
                            <div className="stat-icon-wrapper bg-teal">
                                <FaCalendarPlus />
                            </div>
                            <div className="stat-data">
                                <div className="stat-label">Tommorrow's Followup</div>
                                <div className="stat-value">
                                    <span className="info-box-number">
                                        <a onClick={() => this.setState({
                                            drawer: true,
                                            drawerParam: { title: "Tommorrow Followup", arr: tommorrowFollowup.arr, count: tommorrowFollowup.total, bgColorClass: "bg-teal", icon: <FaCalendarPlus /> }
                                        })}>{tommorrowFollowup.total}</a>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </Col>
                    <Col span={6}>
                        <div className="stat-card">
                            <div className="stat-icon-wrapper bg-red-soft">
                                <FaCalendarTimes />
                            </div>
                            <div className="stat-data">
                                <div className="stat-label">Missed Followup</div>
                                <div className="stat-value">
                                    <span className="info-box-number">
                                        <a onClick={() => this.setState({
                                            drawer: true,
                                            drawerParam: { title: "Missed Followup", arr: missedFollowup.arr, count: missedFollowup.total, bgColorClass: "bg-red-soft", icon: <FaCalendarTimes /> }
                                        })}>{missedFollowup.total}</a>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </Col>
                </Row>
                {
                    Object.keys(countryWiseVisa).some(key => countryWiseVisa[key].total > 0) ||
                        Object.keys(offerExpected).some(key => offerExpected[key].total > 0) ? <h4 className="section-tag">Expected Work Load:</h4> : null
                }
                {
                    // Offer Pending Country Wise
                    Object.keys(countryWiseVisa)
                        .filter(key => countryWiseVisa[key].total > 0) // only show if total > 0
                        .length > 0 && (
                        <Card
                            title={
                                <div className="card-header-flex">
                                    Countrywise Offer Pending
                                </div>
                            }
                            style={{ marginTop: 20 }}
                            className="modern-list-card"
                        >
                            <Row className="fod-row">
                                {Object.keys(countryWiseVisa)
                                    .filter(key => countryWiseVisa[key].total > 0)
                                    .map(key => {
                                        const item = countryWiseVisa[key];
                                        const meta = countryMeta[key];

                                        return (
                                            <Col span={6} key={key}>
                                                <div className="stat-card">
                                                    <div className={`stat-icon-wrapper ${meta && meta.color || 'bg-blue'}`}>
                                                        {meta && meta.icon || <FaGlobe />}
                                                    </div>
                                                    <div className="stat-data">
                                                        <div className="stat-label">{key}</div>
                                                        <div className="stat-value">
                                                            <a onClick={() =>
                                                                this.setState({
                                                                    drawer: true,
                                                                    drawerParam: {
                                                                        title: key,
                                                                        arr: item.arr,
                                                                        count: item.total,
                                                                        bgColorClass: `${meta && meta.color || 'bg-blue'}`,
                                                                        icon: meta && meta.icon || <FaGlobe />
                                                                    }
                                                                })
                                                            }
                                                            >{item.total}</a>
                                                        </div>
                                                    </div>

                                                </div>
                                            </Col>
                                        );
                                    })}
                            </Row>
                        </Card>
                    )
                }
                {
                    // Offer Pending Country Wise
                    Object.keys(offerExpected)
                        .filter(key => offerExpected[key].total > 0) // only show if total > 0
                        .length > 0 && (
                        <Card
                            title={
                                <div className="card-header-flex">
                                    Offer Expected
                                </div>
                            }
                            style={{ marginTop: 20 }}
                            className="modern-list-card"
                        >
                            <Row className="fod-row">
                                {Object.keys(offerExpected)
                                    .filter(key => offerExpected[key].total > 0)
                                    .map(key => {
                                        const item = offerExpected[key];
                                        const meta = offerExpectedMeta[key];

                                        return (
                                            <Col span={6} key={key}>
                                                <div className="stat-card">
                                                    <div className={`stat-icon-wrapper ${meta.color || 'bg-blue'}`}>
                                                        {meta.icon}
                                                    </div>
                                                    <div className="stat-data">
                                                        <div className="stat-label">{key}</div>
                                                        <div className="stat-value">
                                                            <a onClick={() =>
                                                                this.setState({
                                                                    drawer: true,
                                                                    drawerParam: {
                                                                        title: key,
                                                                        arr: item.arr,
                                                                        count: item.total,
                                                                        bgColorClass: `${meta.color || 'bg-blue'}`,
                                                                        icon: meta.icon
                                                                    }
                                                                })
                                                            }
                                                            >{item.total}</a>
                                                        </div>
                                                    </div>

                                                </div>
                                            </Col>
                                        );
                                    })}
                            </Row>
                        </Card>
                    )
                }

                <h4 className="section-tag">Visa Application Record:</h4>
                <Row className="fod-row">
                    <Col span={6}>
                        <div className="stat-card">
                            <div className="stat-icon-wrapper bg-blue">
                                <FaLayerGroup />
                            </div>
                            <div className="stat-data">
                                <div className="stat-label">Total Applications</div>
                                <div className="stat-value">
                                    <a onClick={() => this.setState({ drawer: true, drawerParam: { title: "Total Applications", arr: totalApplications.arr, count: totalApplications.total, bgColorClass: "bg-blue", icon: <FaLayerGroup /> } })}>{totalApplications.total}</a>
                                </div>
                            </div>
                        </div>
                    </Col>
                    <Col span={6}>
                        <div className="stat-card">
                            <div className="stat-icon-wrapper bg-green">
                                <FaCheckCircle />
                            </div>
                            <div className="stat-data">
                                <div className="stat-label">Visa Approved</div>
                                <div className="stat-value">
                                    <a onClick={() => this.setState({ drawer: true, drawerParam: { title: "Visa Approved", arr: visaApproved.arr, count: visaApproved.total, bgColorClass: "bg-green", icon: <FaCheckCircle /> } })}>{visaApproved.total}</a>
                                </div>
                            </div>
                        </div>
                    </Col>
                    <Col span={6}>
                        <div className="stat-card">
                            <div className="stat-icon-wrapper bg-red">
                                <FaTimesCircle />
                            </div>
                            <div className="stat-data">
                                <div className="stat-label">Visa Refused</div>
                                <div className="stat-value">
                                    <a onClick={() => this.setState({ drawer: true, drawerParam: { title: "Visa Refused", arr: visaRefused.arr, count: visaRefused.total, bgColorClass: "bg-red", icon: <FaTimesCircle /> } })}>{visaRefused.total}</a>
                                </div>
                            </div>
                        </div>
                    </Col>
                    <Col span={6}>
                        <div className="stat-card">
                            <div className="stat-icon-wrapper bg-orange">
                                <FaUndoAlt />
                            </div>
                            <div className="stat-data">
                                <div className="stat-label">Visa Withdrawn</div>
                                <div className="stat-value">
                                    <a onClick={() => this.setState({ drawer: true, drawerParam: { title: "Visa Withdrawn", arr: visaWithdrawn.arr, count: visaWithdrawn.total, bgColorClass: "bg-orange", icon: <FaUndoAlt /> } })}>{visaWithdrawn.total}</a>
                                </div>
                            </div>
                        </div>
                    </Col>
                    <Col span={6}>
                        <div className="stat-card">
                            <div className="stat-icon-wrapper bg-teal">
                                <FaUniversity />
                            </div>
                            <div className="stat-data">
                                <div className="stat-label">Files At Embassy</div>
                                <div className="stat-value">
                                    <a onClick={() => this.setState({ drawer: true, drawerParam: { title: "Files At Embassy", arr: fileToEmbassy.arr, count: fileToEmbassy.total, bgColorClass: "bg-teal", icon: <FaUniversity /> } })}>{fileToEmbassy.total}</a>
                                </div>
                            </div>
                        </div>
                    </Col>
                    <Col span={6}>
                        <div className="stat-card">
                            <div className="stat-icon-wrapper bg-brown">
                                <FaHandHolding />
                            </div>
                            <div className="stat-data">
                                <div className="stat-label">File Handed Over But Not Processed</div>
                                <div className="stat-value">
                                    <a onClick={() => this.setState({ drawer: true, drawerParam: { title: "File Handed Over But Not Processed", arr: filesHandedNotProcessed.arr, count: filesHandedNotProcessed.total, bgColorClass: "bg-brown", icon: <FaHandHolding /> } })}>{filesHandedNotProcessed.total}</a>
                                </div>
                            </div>
                        </div>
                    </Col>
                    <Col span={6}>
                        <div className="stat-card">
                            <div className="stat-icon-wrapper bg-indigo">
                                <FaPlayCircle />
                            </div>
                            <div className="stat-data">
                                <div className="stat-label">File Ready To Process</div>
                                <div className="stat-value">
                                    <a onClick={() => this.setState({ drawer: true, drawerParam: { title: "File Ready To Process", arr: filesReadyToProcess.arr, count: filesReadyToProcess.total, bgColorClass: "bg-indigo", icon: <FaPlayCircle /> } })}>{filesReadyToProcess.total}</a>
                                </div>
                            </div>
                        </div>
                    </Col>
                    <Col span={6}>
                        <div className="stat-card">
                            <div className="stat-icon-wrapper bg-warning">
                                <FaSpinner />
                            </div>
                            <div className="stat-data">
                                <div className="stat-label">File In Progress</div>
                                <div className="stat-value">
                                    <a onClick={() => this.setState({ drawer: true, drawerParam: { title: "File In Progress", arr: fileInProgress.arr, count: fileInProgress.total, bgColorClass: "bg-warning", icon: <FaSpinner /> } })}>{fileInProgress.total}</a>
                                </div>
                            </div>
                        </div>
                    </Col>
                    <Col span={6}>
                        <div className="stat-card">
                            <div className="stat-icon-wrapper bg-lime">
                                <FaMoneyBillWave />
                            </div>
                            <div className="stat-data">
                                <div className="stat-label">Fees Paid</div>
                                <div className="stat-value">
                                    <a onClick={() => this.setState({ drawer: true, drawerParam: { title: "Fees Paid", arr: feePaid.arr, count: feePaid.total, bgColorClass: "bg-lime", icon: <FaMoneyBillWave /> } })}>{feePaid.total}</a>
                                </div>
                            </div>
                        </div>
                    </Col>
                    <Col span={6}>
                        <div className="stat-card">
                            <div className="stat-icon-wrapper bg-cyan">
                                <FaClipboardCheck />
                            </div>
                            <div className="stat-data">
                                <div className="stat-label">Checklist Issued</div>
                                <div className="stat-value">
                                    <a onClick={() => this.setState({ drawer: true, drawerParam: { title: "Checklist Issued", arr: checkListIssued.arr, count: checkListIssued.total, bgColorClass: "bg-cyan", icon: <FaClipboardCheck /> } })}>{checkListIssued.total}</a>
                                </div>
                            </div>
                        </div>
                    </Col>
                    <Col span={6}>
                        <div className="stat-card">
                            <div className="stat-icon-wrapper bg-orange">
                                <FaUndoAlt />
                            </div>
                            <div className="stat-data">
                                <div className="stat-label">Refund Waiting</div>
                                <div className="stat-value">
                                    <a onClick={() => this.setState({
                                        drawer: true,
                                        drawerParam: {
                                            title: "Refund Waiting",
                                            arr: refundWaiting.arr,
                                            count: refundWaiting.total,
                                            bgColorClass: "bg-orange",
                                            icon: <FaUndoAlt />
                                        }
                                    })}>
                                        {refundWaiting.total}
                                    </a>
                                </div>
                            </div>
                        </div>
                    </Col>
                    <Col span={6}>
                        <div className="stat-card">
                            <div className="stat-icon-wrapper bg-purple">
                                <FaUsers />
                            </div>
                            <div className="stat-data">
                                <div className="stat-label">Pending Consultancy</div>
                                <div className="stat-value">
                                    <a onClick={() => this.setState({
                                        drawer: true,
                                        drawerParam: { title: "Pending Consultancy", arr: pendingConsultancy.arr, count: pendingConsultancy.total, bgColorClass: "bg-purple", icon: <FaUsers /> }
                                    })}>{pendingConsultancy.total}</a>
                                </div>
                            </div>
                        </div>
                    </Col>


                </Row>

                {/* Progress Cards */}
                <Row className="fod-row" gutter={[24, 0]}>
                    {/* Country Wise Card */}
                    <Col span={8}>
                        {Object.keys(counsellorWiseProgress || {}).length > 0 && (
                            <Card
                                title="Counsellor Wise (In Progress)"
                                className="modern-list-card"
                                style={{ marginTop: 20 }}
                                bodyStyle={{ padding: "12px 0" }} // Removes default card padding for custom rows
                            >
                                <div className="card-list-container">
                                    {Object.keys(counsellorWiseProgress).map((key) => {
                                        const item = counsellorWiseProgress[key];
                                        return (
                                            <div className="list-item-row" key={key}>
                                                <span className="label-text">
                                                    {key}
                                                </span>
                                                <div
                                                    className="count-badge"
                                                    onClick={() => this.setState({
                                                        drawer: true,
                                                        drawerParam: {
                                                            title: key + " File In Progress",
                                                            arr: item.arr,
                                                            count: item.total,
                                                            bgColorClass: "bg-blue"
                                                        }
                                                    })}
                                                >
                                                    {item.total}
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>
                            </Card>
                        )}
                    </Col>
                    <Col span={8}>
                        {Object.keys(countryWiseInProgress || {}).length > 0 && (
                            <Card
                                title="Country Wise (In Progress)"
                                className="modern-list-card"
                                style={{ marginTop: 20 }}
                                bodyStyle={{ padding: "12px 0" }} // Removes default card padding for custom rows
                            >
                                <div className="card-list-container">
                                    {Object.keys(countryWiseInProgress).map((key) => {
                                        const item = countryWiseInProgress[key];
                                        return (
                                            <div className="list-item-row" key={key}>
                                                <span className="label-text">
                                                    {key}
                                                </span>
                                                <div
                                                    className="count-badge"
                                                    onClick={() => this.setState({
                                                        drawer: true,
                                                        drawerParam: {
                                                            title: key + " File In Progress",
                                                            arr: item.arr,
                                                            count: item.total,
                                                            bgColorClass: "bg-blue"
                                                        }
                                                    })}
                                                >
                                                    {item.total}
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>
                            </Card>
                        )}
                    </Col>
                    <Col span={8}>
                        {Object.keys(branchWiseInProgress || {}).length > 0 && (
                            <Card
                                title="Branch Wise (In Progress)"
                                className="modern-list-card"
                                style={{ marginTop: 20 }}
                                bodyStyle={{ padding: "12px 0" }} // Removes default card padding for custom rows
                            >
                                <div className="card-list-container">
                                    {Object.keys(branchWiseInProgress).map((key) => {
                                        const item = branchWiseInProgress[key];
                                        return (
                                            <div className="list-item-row" key={key}>
                                                <span className="label-text">
                                                    {key}
                                                </span>
                                                <div
                                                    className="count-badge"
                                                    onClick={() => this.setState({
                                                        drawer: true,
                                                        drawerParam: {
                                                            title: key + " File In Progress",
                                                            arr: item.arr,
                                                            count: item.total,
                                                            bgColorClass: "bg-blue"
                                                        }
                                                    })}
                                                >
                                                    {item.total}
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>
                            </Card>
                        )}
                    </Col>

                </Row>
            </div>
        );
    }
}



const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}


export default connect(mapDispatchToProps)
    (VisaSupportDashboard)